import React from 'react';

const Cards = ({ children }) => {


  return (
    <div className=''>
      {children}
    </div>
  );
};

export default Cards;

